import { createReducer, createActions } from 'reduxsauce';
import Immutable from 'seamless-immutable';

/* Types & Action Creators */

const { Types, Creators } = createActions({
  getCtesRequest: null,
  getCtesSuccess: ['ctes'],
  getCtesFailure: ['error'],
  confirmPaymentRequest: ['id', 'closeModal'],
  confirmPaymentSuccess: null,
  confirmPaymentFailure: ['error'],
  cancelPaymentRequest: ['id'],
  cancelPaymentSuccess: null,
  cancelPaymentFailure: ['error'],
  // CRUD de Viagens
  getViagensRequest: ['filtros'],
  getViagensSuccess: ['viagens'],
  getViagensFailure: ['error'],
  addViagemRequest: ['viagem', 'closeModal'],
  addViagemSuccess: ['viagem'],
  addViagemFailure: ['error'],
  updateViagemRequest: ['id', 'viagem', 'closeModal'],
  updateViagemSuccess: ['viagem'],
  updateViagemFailure: ['error'],
  removeViagemRequest: ['id'],
  removeViagemSuccess: ['id'],
  removeViagemFailure: ['error'],
  openModalViagem: ['viagem'],
  closeModalViagem: null,
});

export const TripTypes = Types;
export default Creators;

/* Initial State */

export const INITIAL_STATE = Immutable({
  ctes: [],
  viagens: [],
  isLoading: false,
  error: null,
  modalViagemOpen: false,
  viagemSelected: null,
});

/* Reducers */

const getCtesRequest = (state) =>
  state.merge({
    isLoading: true,
  });

const getCtesSuccess = (state, { ctes }) =>
  state.merge({
    ctes,
    isLoading: false,
  });

const getCtesFailure = (state, { error }) =>
  state.merge({
    error,
    isLoading: false,
  });

const confirmPaymentRequest = (state) =>
  state.merge({
    isLoading: true,
  });

const confirmPaymentSuccess = (state) =>
  state.merge({
    isLoading: false,
  });

const confirmPaymentFailure = (state) =>
  state.merge({
    isLoading: false,
  });

const cancelPaymentRequest = (state) =>
  state.merge({
    isLoading: true,
  });

const cancelPaymentSuccess = (state) =>
  state.merge({
    isLoading: false,
  });

const cancelPaymentFailure = (state) =>
  state.merge({
    isLoading: false,
  });

// Reducers para CRUD de Viagens
const getViagensRequest = (state) =>
  state.merge({
    isLoading: true,
  });

const getViagensSuccess = (state, { viagens }) =>
  state.merge({
    viagens,
    isLoading: false,
  });

const getViagensFailure = (state, { error }) =>
  state.merge({
    error,
    isLoading: false,
  });

const addViagemRequest = (state) =>
  state.merge({
    isLoading: true,
  });

const addViagemSuccess = (state, { viagem }) =>
  state.merge({
    viagens: [...state.viagens, viagem],
    isLoading: false,
    modalViagemOpen: false,
    viagemSelected: null,
  });

const addViagemFailure = (state, { error }) =>
  state.merge({
    error,
    isLoading: false,
  });

const updateViagemRequest = (state) =>
  state.merge({
    isLoading: true,
  });

const updateViagemSuccess = (state, { viagem }) =>
  state.merge({
    viagens: state.viagens.map((v) => (v.id === viagem.id ? viagem : v)),
    isLoading: false,
    modalViagemOpen: false,
    viagemSelected: null,
  });

const updateViagemFailure = (state, { error }) =>
  state.merge({
    error,
    isLoading: false,
  });

const removeViagemRequest = (state) =>
  state.merge({
    isLoading: true,
  });

const removeViagemSuccess = (state, { id }) =>
  state.merge({
    viagens: state.viagens.filter((v) => v.id !== id),
    isLoading: false,
  });

const removeViagemFailure = (state, { error }) =>
  state.merge({
    error,
    isLoading: false,
  });

const openModalViagem = (state, { viagem }) =>
  state.merge({
    modalViagemOpen: true,
    viagemSelected: viagem || null,
  });

const closeModalViagem = (state) =>
  state.merge({
    modalViagemOpen: false,
    viagemSelected: null,
  });

/* Reducers to types */

export const reducer = createReducer(INITIAL_STATE, {
  [Types.GET_CTES_REQUEST]: getCtesRequest,
  [Types.GET_CTES_SUCCESS]: getCtesSuccess,
  [Types.GET_CTES_FAILURE]: getCtesFailure,
  [Types.CONFIRM_PAYMENT_REQUEST]: confirmPaymentRequest,
  [Types.CONFIRM_PAYMENT_SUCCESS]: confirmPaymentSuccess,
  [Types.CONFIRM_PAYMENT_FAILURE]: confirmPaymentFailure,
  [Types.CANCEL_PAYMENT_REQUEST]: cancelPaymentRequest,
  [Types.CANCEL_PAYMENT_SUCCESS]: cancelPaymentSuccess,
  [Types.CANCEL_PAYMENT_FAILURE]: cancelPaymentFailure,
  [Types.GET_VIAGENS_REQUEST]: getViagensRequest,
  [Types.GET_VIAGENS_SUCCESS]: getViagensSuccess,
  [Types.GET_VIAGENS_FAILURE]: getViagensFailure,
  [Types.ADD_VIAGEM_REQUEST]: addViagemRequest,
  [Types.ADD_VIAGEM_SUCCESS]: addViagemSuccess,
  [Types.ADD_VIAGEM_FAILURE]: addViagemFailure,
  [Types.UPDATE_VIAGEM_REQUEST]: updateViagemRequest,
  [Types.UPDATE_VIAGEM_SUCCESS]: updateViagemSuccess,
  [Types.UPDATE_VIAGEM_FAILURE]: updateViagemFailure,
  [Types.REMOVE_VIAGEM_REQUEST]: removeViagemRequest,
  [Types.REMOVE_VIAGEM_SUCCESS]: removeViagemSuccess,
  [Types.REMOVE_VIAGEM_FAILURE]: removeViagemFailure,
  [Types.OPEN_MODAL_VIAGEM]: openModalViagem,
  [Types.CLOSE_MODAL_VIAGEM]: closeModalViagem,
});
